var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',[_c('b-container',{staticClass:"mt-3"},[_c('p',[_vm._v("404: page not found")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }